export default function Pagination({ pagination, handlePageChange, loading }) {
  const navButtons = [
    { content: "<<", page: 1, enabled: pagination.has_previous },
    {
      content: "<",
      page: pagination.current_page - 1,
      enabled: pagination.has_previous,
    },
    {
      content: ">",
      page: pagination.current_page + 1,
      enabled: pagination.has_next,
    },
    {
      content: ">>",
      page: pagination.total_pages,
      enabled: pagination.has_next,
    },
  ];
  return (
    <div className="flex items-center justify-center bg-white p-4 rounded-lg shadow-sm border mt-4">
      <div className="flex items-center space-x-2">
        {navButtons.slice(0, 2).map((btn) => (
          <PaginationButton
            key={btn.content}
            {...btn}
            handlePageChange={handlePageChange}
            loading={loading}
          />
        ))}
        <div className="flex items-center space-x-1">
          {[...Array(Math.min(5, pagination.total_pages))].map((_, index) => {
            let pageNum;

            if (pagination.total_pages <= 5) {
              pageNum = index + 1;
            } else if (pagination.current_page <= 3) {
              pageNum = index + 1;
            } else if (pagination.current_page >= pagination.total_pages - 2) {
              pageNum = pagination.total_pages - 4 + index;
            } else {
              pageNum = pagination.current_page - 2 + index;
            }

            return (
              <button
                key={pageNum}
                onClick={() => handlePageChange(pageNum)}
                disabled={loading}
                className={`px-3 py-2 text-sm  border ${
                  pageNum === pagination.current_page
                    ? "bg-primary-blue text-white border-blue-500"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                } disabled:opacity-50 disabled:cursor-not-allowed`}
              >
                {pageNum}
              </button>
            );
          })}
        </div>
        {navButtons.slice(2).map((btn) => (
          <PaginationButton
            key={btn.content}
            {...btn}
            handlePageChange={handlePageChange}
            loading={loading}
          />
        ))}
      </div>
    </div>
  );
}

function PaginationButton({
  content,
  handlePageChange,
  loading,
  enabled,
  page,
}) {
  return (
    <button
      onClick={() => handlePageChange(page)}
      disabled={!enabled || loading}
      className="p-2 border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      title={content}
    >
      {content}
    </button>
  );
}
